module.exports = __webpack_public_path__ + "media/images/tab-setting-c22ed0e3fa1708063b9b915f8e0a1cbb.png";